<template>
  <div class="welcome"></div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {},
  beforeRouteEnter(to, from, next) {
    console.log(to, from, next)
    next(vm => {
      vm.$router.replace(from.path)
    })
  }
}
</script>
